
import React from "react";
import ReactDOM from "react-dom";
import { createStore, applyMiddleware, compose } from "redux";
import { Provider } from "react-redux";
import thunk from "redux-thunk";
import rootReducer from "./reducer/index";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
 rootReducer,
 composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
 <Router>
 <Provider store={store}>
     <App />
 </Provider>
 </Router>,
 document.getElementById("root")
);